export default __webpack_public_path__ + "static/media/messageSent.3a610be0.svg";